import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ComplexModalTemplate } from '@connect-services/client/components/complexe-modal/complex-modal-template.component';
import { LoadingComponent } from '@shared/client/components/loading/loading.component';

export interface LoaderModalData {
    message?: string;
    title?: string;
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ComplexModalTemplate, LoadingComponent],
    selector: 'app-loader-modal',
    templateUrl: './loader-modal.component.html',
})
export class LoaderModalComponent {
    protected readonly data = inject<LoaderModalData>(MAT_DIALOG_DATA, { optional: true });
    protected dialogRef = inject(MatDialogRef<LoaderModalComponent>);
    protected readonly hasError = signal<boolean>(false);
    protected readonly message = signal<string>(this.data?.message ?? '');
    protected readonly title = signal<string>(this.data?.title ?? '');

    public setHasError(hasError: boolean): void {
        this.hasError.set(hasError);
    }

    public setMessage(message: string): void {
        this.message.set(message);
    }

    public setTitle(title: string): void {
        this.title.set(title);
    }
}
